import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/parts/Main'
import Suitecrm from '@/components/pages/Suitecrm'
import Waterman3 from '@/components/pages/Waterman3'
import Importsubst from '@/components/pages/Importsubst'
import Mrpq321 from '@/components/pages/Mrpq321'
import bizopsdev321 from '@/components/pages/bizopsdev321'
import teamasservice from '@/components/pages/teamasservice'
import App321 from '@/components/pages/App321'
import App321Doc from '@/components/pages/App321Doc'
import Price from '@/components/pages/Price'
import License from '@/components/pages/License'
// import Vacancies from '@/components/pages/Vacancies'
import About from '@/components/pages/About'
import Contacts from '@/components/pages/Contacts'
import Waterman20 from '@/components/pages/Waterman20'
import WatermanPromo from '@/components/pages/WatermanPromo'
import InterviewWaterman20 from '@/components/pages/InterviewWaterman20'
import NotFound from '@/components/pages/404page'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Main', component: Main },
    { path: '/products/suitecrm', name: 'Suitecrm', component: Suitecrm },
    { path: '/products/waterman3', name: 'Waterman3', component: Waterman3 },
    { path: '/products/importsubst', name: 'Importsubst', component: Importsubst },
    { path: '/products/mrpq321', name: 'Mrpq321', component: Mrpq321 },
    { path: '/products/bizopsdev321', name: 'BizOpsDev321', component: bizopsdev321 },
    { path: '/products/teamasservice', name: 'Team-as-a-Service', component: teamasservice },
    { path: '/products/app321', name: 'App321', component: App321 },
    { path: '/products/app321doc', name: 'App321Doc', component: App321Doc },
    { path: '/price', name: 'Price', component: Price },
    { path: '/license', name: 'License', component: License },
    //{ path: '/vacancies', name: 'Vacancies', component: Vacancies },
    { path: '/about', name: 'About', component: About },
    { path: '/contacts', name: 'Contacts', component: Contacts },
    { path: '/waterman-20', name: 'Waterman20', component: Waterman20 },
    { path: '/waterman-promo', name: 'WatermanPromo', component: WatermanPromo },
    { path: '/interviewWaterman20', name: 'InterviewWaterman20', component: InterviewWaterman20 },
    { path: '/404', name: 'NotFound', component: NotFound },
    { path: '*', redirect: '/404' }
  ],
  linkActiveClass: "active-no-exact", // active class for non-exact links.
  linkExactActiveClass: "active", // active class for *exact* links.
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js